// The browser reports a benign "ResizeObserver loop completed with undelivered
// notifications" (and the older "loop limit exceeded") error whenever an observer
// callback causes further layout changes within the same delivery cycle — which
// React Flow, auto-resizing textareas, and flex/grid reflows all do routinely.
// It is harmless (the browser simply retries next frame), but CRA's dev error
// overlay surfaces it as a full-screen ERROR.
//
// Deferring each ResizeObserver callback to the next animation frame breaks the
// synchronous loop, so the browser considers all notifications delivered and never
// raises the error — with the same resize behaviour one frame later.
export function installResizeObserverLoopFix(): void {
  if (typeof window === 'undefined' || !('ResizeObserver' in window)) return;
  const Native = window.ResizeObserver as typeof ResizeObserver & { __loopFixed?: boolean };
  if (Native.__loopFixed) return;   // guard against double-install (StrictMode / HMR)

  class PatchedResizeObserver extends Native {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  }
  (PatchedResizeObserver as typeof ResizeObserver & { __loopFixed?: boolean }).__loopFixed = true;
  window.ResizeObserver = PatchedResizeObserver;
}
